import React from "react";
import ErrorView from "./ErrorView/ErrorView";
import analyticsHelper from "../helpers/analytics.helper";

export default class ErrorBoundary extends React.Component {

  state = {
    error: null,
  }

  static getDerivedStateFromError(error) {
    return {error};
  }

  componentDidCatch(error, errorInfo) {
    analyticsHelper.componentError(error, errorInfo);
  }

  render() {
    return this.state.error
      ? <ErrorView error={this.state.error} />
      : this.props.children;
  }
}